import React from "react";
import { NavLink, useLocation, Link } from "react-router-dom";
import { Home, Clock, Calendar, User, BarChart3, Settings, Upload, Shield, Download } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Nav() {
  const { user } = useAuth();
  const location = useLocation();
  const base = "text-sm text-muted-foreground hover:text-foreground transition-colors inline-flex items-center h-14";
  const active = "text-foreground border-b-2 brand-red-border";
  const isAdmin = user && (user.role === 'admin' || user.role === 'superadmin');
  
  // Determine if we're in the timekeeping section
  const timekeepingPaths = ['/track', '/reports', '/export', '/import', '/manage', '/admin'];
  const isInTimekeeping = timekeepingPaths.some(path => location.pathname.startsWith(path));
  
  // Determine if we're on the calendar page
  const isOnCalendar = location.pathname.startsWith('/calendar');
  
  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background/80 backdrop-blur">
      <div className="mx-auto max-w-6xl px-4 h-14 flex items-center justify-between">
        <Link to="/hub" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <span className="font-semibold tracking-tight">
            <span className="brand-red">sgt</span><span className="text-black">.</span><span className="text-black">law</span><span className="text-black"> web apps</span>
          </span>
        </Link>
        <nav className="flex items-center gap-6">
          {isOnCalendar ? (
            // Calendar-specific navigation
            <>
              <NavLink to="/hub" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <Home className="size-4"/> Hub
              </NavLink>
              <NavLink to="/calendar?tab=month" className={`${base} gap-2 ${location.pathname === '/calendar' && (!location.search || location.search.includes('tab=month')) ? active : ""}`}>
                <Calendar className="size-4"/> Calendar
              </NavLink>
              <NavLink to="/calendar?tab=list" className={`${base} ${location.pathname === '/calendar' && location.search.includes('tab=list') ? active : ""}`}>
                List View
              </NavLink>
              <NavLink to="/calendar?tab=cases" className={`${base} ${location.pathname === '/calendar' && location.search.includes('tab=cases') ? active : ""}`}>
                Cases
              </NavLink>
              <NavLink to="/calendar?tab=categories" className={`${base} ${location.pathname === '/calendar' && location.search.includes('tab=categories') ? active : ""}`}>
                Categories
              </NavLink>
              <NavLink to="/account" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <User className="size-4"/> Account
              </NavLink>
            </>
          ) : isInTimekeeping ? (
            // Full navigation for timekeeping section
            <>
              <NavLink to="/hub" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <Home className="size-4"/> Hub
              </NavLink>
              <NavLink to="/track" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <Clock className="size-4"/> Track
              </NavLink>
              <NavLink to="/reports" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <BarChart3 className="size-4"/> Reports
              </NavLink>
              {isAdmin && (
                <NavLink to="/export" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                  <Download className="size-4"/> Export
                </NavLink>
              )}
              <NavLink to="/import" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <Upload className="size-4"/> Import
              </NavLink>
              {isAdmin && (
                <NavLink to="/manage" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                  <Settings className="size-4"/> Manage
                </NavLink>
              )}
              {isAdmin && (
                <NavLink to="/admin" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                  <Shield className="size-4"/> Admin
                </NavLink>
              )}
              <NavLink to="/account" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <User className="size-4"/> Account
              </NavLink>
            </>
          ) : (
            // Simplified navigation for other sections
            <>
              <NavLink to="/hub" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <Home className="size-4"/> Hub
              </NavLink>
              <NavLink to="/track" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <Clock className="size-4"/> Timekeeping
              </NavLink>
              <NavLink to="/calendar" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <Calendar className="size-4"/> Calendar
              </NavLink>
              <NavLink to="/account" className={({ isActive }) => `${base} gap-2 ${isActive ? active : ""}`}>
                <User className="size-4"/> Account
              </NavLink>
            </>
          )}
        </nav>
        <div className="flex items-center gap-2" />
      </div>
    </header>
  );
}